import { View } from '@react-pdf/renderer'
import { Icon } from '../icon'
import { useTheme } from '../../hooks/use-theme'

export function Score({ id, rank }) {
  const theme = useTheme()

  return (
    <View style={{ flexDirection: 'row' }}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Icon
          key={`${id}-${index}`}
          size={5.5}
          name="dot"
          style={{ marginRight: 1 }}
          color={
            index <= rank - 1 ? theme.colors.primary : theme.colors.ligthGray
          }
        />
      ))}
    </View>
  )
}
